module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }